export const formatNumberWithCommas = (number): string => {
  const intlNumber = Intl.NumberFormat('en-US');

  return intlNumber.format(number);
};
